/**
 * TanStack Query hooks for `custom-login-domain-for-publisher-portal`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	customLoginDomainForPublisherPortalQueryKeys,
	type CreateCustomLoginDomainForPublisherPortalBody,
	type ListCustomLoginDomainForPublisherPortalResponse,
	type CustomLoginDomainForPublisherPortalRow,
} from "./api";

export function useCustomLoginDomainForPublisherPortalList(): UseQueryResult<ListCustomLoginDomainForPublisherPortalResponse, Error> {
	return useQuery({
		queryKey: customLoginDomainForPublisherPortalQueryKeys.list(),
		queryFn: list,
	});
}

export function useCustomLoginDomainForPublisherPortalCreate(): UseMutationResult<CustomLoginDomainForPublisherPortalRow, Error, CreateCustomLoginDomainForPublisherPortalBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customLoginDomainForPublisherPortalQueryKeys.all });
		},
	});
}

export function useCustomLoginDomainForPublisherPortalDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: customLoginDomainForPublisherPortalQueryKeys.all });
		},
	});
}
